import React, { PureComponent, PropTypes } from 'react';
import '@atlaskit/css-reset';
import Nav, { AkContainerItem, AkContainerTitle as NavHeader, AkSearchDrawer } from '@atlaskit/navigation';
import Page, { Grid, GridColumn } from '@atlaskit/page';
import { akColorN0 } from '@atlaskit/util-shared-styles';
import DashboardIcon from '@atlaskit/icon/glyph/dashboard';
import BranchesIcon from '@atlaskit/icon/glyph/bitbucket/branches';
import ReposIcon from '@atlaskit/icon/glyph/bitbucket/repositories';
import SearchIcon from '@atlaskit/icon/glyph/search';
import ArrowleftIcon from '@atlaskit/icon/glyph/arrowleft';
import AtlassianIcon from '@atlaskit/icon/glyph/atlassian';

import { Link } from 'react-router';
import { BASE_URL } from '../config';
import Footer from '../components/Footer';
import nucleusImg from '../images/nucleus.png';
import SearchDrawerContent from '../components/SearchDrawer';

const myLinks = [
  [`${BASE_URL}/`, 'Components', DashboardIcon],
  [`${BASE_URL}/metrics.html`, 'Metrics', ReposIcon],
  [`${BASE_URL}/dependencies.html`, 'Dependencies', BranchesIcon],
];

const ContainerHeader = () => <Link to="/">
  <NavHeader
    text="AtlasKit Registry"
    icon={<img alt="nucleus" src={nucleusImg} />}
  />
</Link>;

export default class App extends PureComponent {

  state = {
    isSearchDrawerOpen: false,
    navigationWidth: 284,
    isNavigationOpen: true,
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  render() {
    return (
      <Page
        navigationWidth={this.state.navigationWidth}
        navigation={
          <Nav
            width={this.state.navigationWidth}
            isOpen={this.state.isNavigationOpen}
            onResize={({ width, isOpen }) => {
              this.setState({
                navigationWidth: width,
                isNavigationOpen: isOpen,
              });
            }}
            containerHeaderComponent={() => <ContainerHeader />}
            globalPrimaryIcon={
              <AtlassianIcon size="medium" label="Atlassian" />
            }
            globalSearchIcon={
              <span style={{ color: this.state.isSearchDrawerOpen ? akColorN0 : 'white' }}>
              <SearchIcon label="Search icon" />
            </span>
            }
            drawerBackIcon={<ArrowleftIcon label="Back icon" size="medium" />}
            isResizeable
            hasBlanket
            onSearchDrawerOpen={() => {
              this.setState({ isSearchDrawerOpen: true });
              if (this.searchInputRef) {
                this.searchInputRef.focus();
              }
            }}
            openDrawer={false}
            drawers={[
              (<AkSearchDrawer
                backIcon={<ArrowleftIcon label="Back icon" size="medium" />}
                isOpen={this.state.isSearchDrawerOpen}
                header={<ContainerHeader />}
                key="search"
                onBackButton={() => {this.setState({ isSearchDrawerOpen: false })}}
              >
                <SearchDrawerContent
                  onResultClicked={() => (this.setState({ isSearchDrawerOpen: false }))}
                  onSearchInputRef={(ref) => {
                    this.searchInputRef = ref;
                  }}/>
              </AkSearchDrawer>),
            ]}
          >
            {
              myLinks.map(link => {
                const [url, title, Icon] = link;
                return (
                  <Link key={url} to={url}>
                    <AkContainerItem
                      icon={<Icon label={title} />}
                      text={title}
                      isSelected={this.context.router.isActive(url, true)}
                    />
                  </Link>
                );
              })
            }
          </Nav>
        }
      >
        <Grid layout="fluid">
          <GridColumn>
            {this.props.children}
            <Footer />
          </GridColumn>
        </Grid>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/App.jsx